import React from "react";
import { motion } from "framer-motion";
import smileLogo from "../assets/smilelogo.png";

export default function Loader() {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-[#F8FBFC] to-white flex flex-col items-center justify-center z-[9999]">
      
      {/* ✅ Logo with subtle animation */}
      <motion.div
        animate={{ 
          y: [0, -10, 0, -5, 0],
          scale: [1, 1.03, 1, 1.02, 1]
        }}
        transition={{ 
          duration: 1.2,
          repeat: Infinity,
          ease: "easeInOut"
        }}
        className="relative mb-6"
      >
        {/* Glow effect behind logo */}
        <div className="absolute inset-0 bg-gradient-to-r from-teal-400 to-teal-600 rounded-full blur-2xl opacity-60 animate-pulse"></div>
        
        {/* Logo Image */}
        <img 
          src={smileLogo} 
          alt="IQRA Multispeciality Dental Clinic" 
          className="relative w-24 h-24 md:w-28 md:h-28 object-contain rounded-full bg-white/10 backdrop-blur-sm p-2 shadow-xl"
        />
        
        {/* ✅ Subtle teal dots instead of sparkle emojis */}
        <motion.div
          animate={{ 
            scale: [0, 1, 0], 
            opacity: [0, 0.6, 0],
            y: [0, -8, 0]
          }}
          transition={{ duration: 1.5, repeat: Infinity, delay: 0.3 }}
          className="absolute -top-2 -right-2 w-2 h-2 rounded-full bg-teal-400"
        />
        <motion.div
          animate={{ 
            scale: [0, 1, 0], 
            opacity: [0, 0.6, 0],
            y: [0, 8, 0]
          }}
          transition={{ duration: 1.5, repeat: Infinity, delay: 0.6 }}
          className="absolute -bottom-1 -left-1 w-1.5 h-1.5 rounded-full bg-teal-300"
        />
      </motion.div>

      {/* ✅ Clinic Name - Full name split into two lines */}
      <motion.h1 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center"
      >
        <span className="text-2xl sm:text-3xl md:text-4xl font-bold bg-gradient-to-r from-[#2CA6B1] to-[#4FD1C5] bg-clip-text text-transparent block">
          IQRA Multispeciality
        </span>
        <span className="text-xl sm:text-2xl md:text-3xl font-bold bg-gradient-to-r from-[#2CA6B1] to-[#4FD1C5] bg-clip-text text-transparent block">
          Dental Clinic
        </span>
      </motion.h1>
      
      {/* ✅ Professional Tagline */}
      <motion.p 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="text-gray-400 text-sm font-medium mt-2 tracking-wide"
      >
        Advanced Dental Care Starts Here
      </motion.p>
      
      {/* ✅ Wider Progress Bar */}
      <motion.div 
        initial={{ opacity: 0, scaleX: 0 }}
        animate={{ opacity: 1, scaleX: 1 }}
        transition={{ duration: 0.5, delay: 0.3 }}
        className="mt-6 w-56 h-1.5 bg-gray-200 rounded-full overflow-hidden shadow-inner"
      >
        <motion.div 
          animate={{ x: ["-100%", "100%"] }}
          transition={{ duration: 1.2, repeat: Infinity, ease: "linear" }}
          className="h-full w-full bg-gradient-to-r from-[#2CA6B1] to-[#4FD1C5] rounded-full"
        />
      </motion.div>
      
      {/* Loading dots */}
      <div className="flex gap-1.5 mt-4">
        {[0, 1, 2].map((dot) => (
          <motion.div
            key={dot}
            animate={{ y: [0, -5, 0] }}
            transition={{ duration: 0.6, repeat: Infinity, delay: dot * 0.15 }}
            className="w-1.5 h-1.5 bg-teal-400 rounded-full"
          />
        ))}
      </div>
    </div>
  );
}